<script setup lang="ts">
import type { TypeFooterDataItems } from "@ViewPages/Main/Components/commonTypes";
import Container                    from "@ViewCommonComponents/Container.vue";

defineProps<TypeFooterDataItems>();

const structured_data = `
    <!-- Start: Google Structured Data Markup -->
    <script type="application/ld+json">
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "https://mci.com.ua",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Україна, Одеса",
                "postalCode": "65033",
                "streetAddress": "вул. Желябова, 4В"
            },
            "email": "am@mci.com.ua",
            "faxNumber": "+380 (73) 799 88 88",
            "name": "Marine Cargo International",
            "telephone": "+380 (73) 799 88 88",
            "logo": "https://mci.com.ua/src/img/logo-social.jpg",
            "image": "https://mci.com.ua/src/img/logo-social.jpg"
        }`;
</script>

<template>
    <Container>
        <div class="footer__bottom">
            <div class="footer__bottom-top
                        grid
                        grid-cols-2
                        md:grid-cols-3
                        xl:grid-cols-4-auto
                        grid-rows-3-auto
                        md:grid-rows-2-auto
                        xl:grid-rows-1
                        xl:justify-items-center
                        max-xl:gap-y-5 xl:gap-x-3
                        mb-45px xl:mb-12">

                <div class="footer__item
                            col-start-1 col-end-3
                            md:col-end-4
                            xl:col-start-1 xl:col-end-2
                            xl:justify-self-start
                            xl:max-w-96
                            max-xl:mb-25px">
                    {{ __('footer_bottom_location') }}
                </div>

                <div class="footer__item
                            col-start-1 col-end-2
                            xl:col-start-3 xl:col-end-4
                            flex flex-col gap-y-5 xl:gap-y-3">
                    <a :href="'tel:' + telephone.replace(/\D/g, '')"
                       v-for="telephone in bottom_data?.telephones">
                        {{ telephone }}
                    </a>
                </div>

                <div class="footer__item
                            col-start-1 col-end-2
                            md:col-start-2 md:col-end-3
                            md:row-start-2 md:row-end-3
                            justify-self-start
                            md:justify-self-center
                            xl:col-start-4 xl:col-end-5
                            xl:row-start-1 xl:row-end-2
                            flex max-xl:flex-col xl:justify-between max-xl:gap-y-5 xl:gap-x-2.5
                            xl:w-full">
                    <a :href="'mailto:' + email" v-for="email in bottom_data?.emails">
                        {{ email }}
                    </a>
                </div>

                <div class="footer__item
                            col-start-2 col-end-3
                            row-start-2 row-end-3
                            md:col-end-4
                            xl:col-start-2 xl:col-end-3
                            xl:row-start-1 xl:row-end-2
                            justify-self-end
                            xl:justify-self-center">
                    <a :href="bottom_data?.instagram_link">
                        <img :src="asset('image/footer/instagram-icon.svg')"
                             width="40" height="40"
                             decoding="async" loading="lazy"
                             alt="Instagram">
                    </a>
                </div>
            </div>

            <div class="footer__bottom-bottom text-center">
                {{ __('footer_bottom_license') }}
            </div>
        </div>
    </Container>

<div v-html="structured_data"></div>
</template>

<style scoped>

</style>
